import { ApplicationMaritalStatusScreen } from "@/interactors/ApplicationMaritalStatusScreen";

export default function MaritalStatus() {
  return <ApplicationMaritalStatusScreen />;
}
